import { NavLink } from 'react-router-dom';
import { useSiteAssets } from '../../features/site-assets/use-site-assets.js';
import { PublicAssetImg } from '../../features/site-assets/PublicAssetImg.js';
import { imageSrc } from '../../features/gallery/cloudinary-url.js';

const LOGO_DISPLAY_WIDTH = 400;

interface NavLinkSpec {
  readonly to: string;
  readonly label: string;
  readonly end?: boolean;
}

const NAV_LINKS: readonly NavLinkSpec[] = [
  { to: '/', label: 'Home', end: true },
  { to: '/about', label: 'About' },
  { to: '/photos', label: 'Photos' },
  { to: '/videos', label: 'Videos' },
  { to: '/events', label: 'Events' },
  { to: '/book', label: 'Book' },
];

function navLinkClass({ isActive }: { isActive: boolean }): string {
  const base = 'rounded px-3 py-2 text-sm font-medium transition-colors';
  return isActive ? `${base} bg-slate-900 text-white` : `${base} text-slate-700 hover:bg-slate-100`;
}

function AdminLoginButton(): JSX.Element {
  return (
    <li className="ml-5">
      <NavLink
        to="/admin/login"
        aria-label="Admin login"
        className="inline-flex items-center justify-center rounded p-1 transition-colors hover:bg-slate-100"
      >
        <img src="/buzzericon.svg" alt="" className="h-8 w-8" decoding="async" />
      </NavLink>
    </li>
  );
}

export function Header(): JSX.Element {
  const { getAsset } = useSiteAssets();
  const logo = getAsset('brand_logo');

  return (
    <header className="border-b border-slate-200 bg-white">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4">
        <NavLink
          to="/"
          className="flex items-center gap-2 text-xl font-semibold tracking-tight text-slate-900"
          aria-label="IGS Game Shows home"
        >
          {logo ? (
            <img
              src={imageSrc(logo.url, LOGO_DISPLAY_WIDTH)}
              alt=""
              className="h-16 w-auto"
              loading="eager"
              decoding="async"
            />
          ) : (
            // Cloudinary admin upload missing → try /logo.svg from public/,
            // otherwise show the wordmark alone.
            <PublicAssetImg
              src="/logo.svg"
              alt=""
              loading="eager"
              className="h-16 w-auto"
              fallback={null}
            />
          )}
          <span>IGS Game Shows</span>
        </NavLink>
        <nav aria-label="Primary">
          <ul className="flex items-center gap-1">
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <NavLink to={link.to} end={link.end ?? false} className={navLinkClass}>
                  {link.label}
                </NavLink>
              </li>
            ))}
            <AdminLoginButton />
          </ul>
        </nav>
      </div>
    </header>
  );
}
